import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { timesheetPeriod } from '../../../../pages/timesheets/helpers';
import classes from './TimesheetMobileCard.module.scss';

export default function TimesheetMobileCard(props) {
  const { info } = props;
  const isApprover = useSelector((state) => state?.accessToParts?.tAndEApprover);

  const { t } = useTranslation();

  return (
    <div className={classes.container}>
      <p className={classes.date}>{timesheetPeriod(info, t)}</p>
      <p className={classes.client}>
        {isApprover ? `${info?.User?.FirstName} ${info?.User?.LastName}` : info?.ClientName}
      </p>
    </div>
  );
}
